import React from 'react';
import Icon from '../../../components/AppIcon';

const GoalTypeSelector = ({ selectedType, onTypeChange }) => {
  const goalTypes = [
    {
      id: 'fixed',
      name: '고정 횟수',
      nameEn: 'Fixed Count',
      icon: 'Target',
      description: '정해진 횟수만큼 증명을 제출하는 챌린지',
      example: '예: 책 10권 읽기, 운동 20회 완료',
      color: 'primary',
    },
    {
      id: 'split',
      name: '분할 목표',
      nameEn: 'Split Goal',
      icon: 'Grid3x3',
      description: '큰 목표를 여러 단계로 나누어 달성하는 챌린지',
      example: '예: 10kg 감량을 1kg씩 10단계로 분할',
      color: 'accent',
    },
    {
      id: 'thirty-day',
      name: '30일 챌린지',
      nameEn: '30-Day Challenge',
      icon: 'Calendar',
      description: '30일 동안 매일 증명을 제출하는 챌린지',
      example: '예: 30일 운동, 30일 독서, 30일 명상',
      color: 'success',
    },
  ];

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-2">
          목표 유형 선택
        </h3>
        <p className="text-sm text-muted-foreground caption">
          챌린지의 목표 달성 방식을 선택하세요
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {goalTypes?.map((type) => {
          const isSelected = selectedType === type?.id;
          const colorClasses = {
            primary: 'border-primary bg-primary/10',
            accent: 'border-accent bg-accent/10',
            success: 'border-success bg-success/10',
          };

          return (
            <button
              key={type?.id}
              type="button"
              onClick={() => onTypeChange(type?.id)}
              className={`relative p-4 md:p-6 rounded-lg border-2 transition-gaming text-left ${
                isSelected
                  ? colorClasses?.[type?.color]
                  : 'border-border bg-card hover:border-muted'
              }`}
            >
              {isSelected && (
                <div className="absolute top-3 right-3 w-6 h-6 bg-primary rounded-full flex items-center justify-center">
                  <Icon name="Check" size={14} color="white" />
                </div>
              )}
              <div className="flex items-start space-x-3 mb-3">
                <div
                  className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-md flex items-center justify-center ${
                    isSelected
                      ? `bg-${type?.color}/20`
                      : 'bg-muted'
                  }`}
                >
                  <Icon
                    name={type?.icon}
                    size={20}
                    color={
                      isSelected
                        ? `var(--color-${type?.color})`
                        : 'var(--color-muted-foreground)'
                    }
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm md:text-base font-heading font-semibold text-foreground mb-1">
                    {type?.name}
                  </h4>
                  <p className="text-xs text-muted-foreground caption">
                    {type?.nameEn}
                  </p>
                </div>
              </div>
              <p className="text-xs md:text-sm text-foreground mb-2">
                {type?.description}
              </p>
              <div className="flex items-start space-x-2 p-2 bg-muted/50 rounded-md">
                <Icon
                  name="Lightbulb"
                  size={14}
                  className="text-muted-foreground flex-shrink-0 mt-0.5"
                />
                <p className="text-xs text-muted-foreground caption">
                  {type?.example}
                </p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default GoalTypeSelector;